// extracted by mini-css-extract-plugin
export const container = "CartList-module--container--2bd9c";
export const cartCard = "CartList-module--cartCard--1laiR";
export const cartCardImg = "CartList-module--cartCardImg--ePG1g";
export const cartCardInfo = "CartList-module--cartCardInfo--1Ocr1";
export const cartCardClose = "CartList-module--cartCardClose--13oX0";
export const cartTotal = "CartList-module--cartTotal--2oTvf";